angular.module('picmonic-common').factory('ClassOfficerService', [
  '$filter',
  function ($filter) {
    return {
      getClassOfficersByLead: function (lead) {
        var self = this;

        if (!lead) {
          return [];
        }

        return $filter('filter')(self.classOfficers, { markets: lead }, true);
      },
      classOfficers: [
        {
          name: 'SGA - Student Government / Council',
          markets: [100, 101, 202, 105, 203],
        },
        { name: 'AMSA - American Medical Student Association', markets: [100] },
        { name: 'SNMA - Student National Medical Association', markets: [100] },
        { name: 'AMA - American Medical Association', markets: [100] },
        { name: 'PhiDE - Phi Delta Epsilon', markets: [100] },
        { name: 'SNA - Student Nursing Association', markets: [101, 202, 203] },
        { name: 'PTK - Phi Theta Kappa', markets: [101, 202] },
        { name: 'SNO - Student Nurses Organization', markets: [101, 202] },
        {
          name: 'HOSA - Health Occupations Students of America',
          markets: [101, 202],
        },
        { name: 'ANS - Association Of Nursing Students', markets: [101, 202] },
        { name: 'Nursing Club', markets: [101, 202] },
        { name: 'PASS - Physician Assistant Student Society', markets: [105] },
        {
          name: 'SAAAPA - Student Academy of the American Academy of Physician Assistants',
          markets: [105],
        },
        { name: 'AAPA - American Academy of PAs', markets: [105] },
        {
          name: 'PASO - Physician Assistant Student Organization',
          markets: [105],
        },
        {
          name: 'AANP - The American Association of Nurse Practitioners',
          markets: [203],
        },
        { name: 'STT - Sigma Theta Tau', markets: [203] },
        { name: 'Other', markets: [100, 101, 202, 105, 203] },
      ],
    };
  },
]);
